import React, { forwardRef } from 'react'
import { dynamicSize } from '../../utils/hooks'
import { withEditableConverter } from '@linqpal/common-frontend/src/hooks'

import { MaskedInputBase } from '@linqpal/common-frontend/src/ui'

interface InputTextPropTypes {
  inputStyle?: any
  onChangeText?: (val: string) => void
  onChange?: (val: string) => void
}

export const InputText = forwardRef(
  ({ inputStyle = {}, ...props }: InputTextPropTypes, ref) => (
    <MaskedInputBase
      ref={ref}
      style={inputStyle}
      innerBorderStyle={{
        paddingLeft: dynamicSize(10),
        paddingRight: dynamicSize(5),
        paddingTop: dynamicSize(32),
        lineHeight: dynamicSize(24),
      }}
      siblingProps={{
        marginRight: dynamicSize(10),
      }}
      {...props}
    />
  ),
)

export const AppMaskedInput = withEditableConverter(InputText)
